const EMPTY_STRING_TEXT = '[empty string]';
const NULL_STRING_TEXT = '[null]';
const UNSERIALIZABLE_STRING_TEXT = '[unserializable]';

export const UNCOPIABLE_VALUES = new Set([
  EMPTY_STRING_TEXT,
  NULL_STRING_TEXT,
  UNSERIALIZABLE_STRING_TEXT,
]);

export function sortedMetadataEntries(metadata: unknown): [key: string, value: string][] {
  if (!metadata || typeof metadata !== 'object') {
    return [];
  }
  return Object.entries(metadata as Record<string, unknown>)
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => [key, formatMetadataValue(value)] as [string, string]);
}

function formatMetadataValue(value: unknown): string {
  if (value === null) {
    return NULL_STRING_TEXT;
  }
  if (typeof value === 'string') {
    if (value.length > 0) return value;
    return EMPTY_STRING_TEXT;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  try {
    return JSON.stringify(value) ?? UNSERIALIZABLE_STRING_TEXT;
  } catch {
    return UNSERIALIZABLE_STRING_TEXT;
  }
}
